export default class HelpMenuController {
    /** @ngInject */
    $onInit() {
        this.helpMenuType = 'APPLICATION_HELP';
    }

    showFeedbackForm() {
        this.helpMenuType = 'FEEDBACK_FORM';
    }

    cancel() {
        this.mdPanelRef.close();
    }
}



// WEBPACK FOOTER //
// ./app/common/help-menu/help-menu.controller.js